import { Button } from '@cian/ui-kit';
import { IButtonProps } from '@cian/ui-kit/button/types';
import * as React from 'react';

import * as styles from './ChatbotButton.css';
import { IChatbotActionButtonSchema } from '../../types/chatbot';

export interface IChatbotButton extends Omit<IButtonProps, 'onClick'> {
  afterIcon?: IButtonProps['beforeIcon'];
  actionButton?: IChatbotActionButtonSchema;
  onClick(actionButton?: IChatbotActionButtonSchema): void;
}

export const ChatbotButton = ({ beforeIcon, afterIcon, onClick, actionButton, ...rest }: IChatbotButton) => {
  const icon = beforeIcon || afterIcon;

  const handleClick = React.useCallback(() => {
    onClick(actionButton);
  }, [actionButton, onClick]);

  return (
    <div className={`${styles['wrapper']} ${afterIcon ? styles['_with-after-icon'] : ''}`}>
      <Button beforeIcon={icon} onClick={handleClick} {...rest} />
    </div>
  );
};
